import { useState } from "react";
import { quickTaskStorage } from "@/utils/quickTaskStorage";
import type { PanelState, QuickTaskPrefill } from "./types";

export function useQuickTaskPanel() {
  const storage = quickTaskStorage();
  const [panelState, setPanelState] = useState<PanelState>(() => storage.getStoredPanelState());
  const [hasEverOpened, setHasEverOpened] = useState(() => storage.getStoredPanelState() !== "CLOSED");

  const [prefill, setPrefill] = useState<QuickTaskPrefill | null>(null);

  const openPanel = () => {
    setHasEverOpened(true);
    setPanelState("OPEN");
    storage.savePanelState("OPEN");
  };

  const minimisePanel = () => {
    setPanelState("MINIFIED");
    storage.savePanelState("MINIFIED");
  };

  const closePanel = () => setPanelState("CLOSED");

  const openNewTask = (customerId: string | null) => {
    if (panelState === "CLOSED" && customerId) {
      setPrefill((current) => ({ requestId: (current?.requestId ?? 0) + 1, customerId }));
    }
    openPanel();
  };

  return { panelState, hasEverOpened, prefill, openPanel, openNewTask, minimisePanel, closePanel };
}
